import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { animateScrollToPage, EMPTY_STRING } from '../questionnaire.utils.jsx';
import className from 'classnames';
import { dispatch } from '../app.store.jsx';
import style from './page.layout.less';
import iconsStyle from '../styles/icons.less';
import { setActivePage, setFieldValue, completeQuestionnaire } from '../app.reducer.jsx';
import { bindActionCreators } from '../app.store.jsx';
import { KEY_CODES } from '../../common/utils.jsx';
import _ from '../i18n.jsx';
import * as ld from 'lodash';

const { ENTER, SPACE } = KEY_CODES;
export default class Page extends Component {
    render() {
        const { title, actionObject, isActive, currentPageIndex, pages, pageName } = this.props;
        const { transition, condition, fieldValues, lastPageIndex, height } = this.props;
        const pageStyle = {};
        const pageIndex = pages.findIndex((currentPage) => currentPage.id === pageName);
        let btnText, iconName,
            isVisible = pageIndex <= lastPageIndex,
            nextPage = lastPageIndex > currentPageIndex ? lastPageIndex : currentPageIndex + 1;
        const isEdited = currentPageIndex < lastPageIndex;
        const isLast = pageIndex === lastPageIndex;
        const pageListSize = pages.length;
        const pageGroup = pageListSize ? pages[pageIndex].group : null;
        const headerIcon = ld.find(Page.ICONS, ({ group }) => group === pageGroup);
        const headerIconName = headerIcon ? headerIcon.icon : null;
        const finishedQuestionnaire = fieldValues.finished || false;
        if ('function' === typeof condition) {
            isVisible &= condition(fieldValues);
        }
        if (0 < pageListSize) {
            btnText = isActive ? _('Continue') : _('Modify');
            iconName = isActive ? 'round-edit' : 'round-continue';
            if (isEdited && isActive) {
                btnText = _('Save Changes');
                iconName = 'round-continue';
            } else if ('welcome-page' === pageName && isLast) {
                btnText = _('Acknowledge');
                iconName = 'round-continue';
            }
            const nextPageCondition = nextPage < pageListSize ? pages[nextPage].condition : null;
            if (nextPageCondition && !nextPageCondition(fieldValues)) {
                nextPage++;
            }
            if ('final-step' === pageName) {
                btnText = _('Complete Questionnaire');
                iconName = EMPTY_STRING;
            }
        }
        const props = { lastPageIndex, pageListSize, nextPage, actionObject, condition, transition, fieldValues };
        if (!isVisible) {
            pageStyle.display = 'none';
        }
        if (!isActive) {
            pageStyle.opacity = 0.7;
        } else {
            pageStyle.opacity = 1;
        }
        if (isLast) {
            pageStyle.minHeight = height;
        }
        const titleIconClassName = className(style.page__headerIcon, iconsStyle[`icon-${headerIconName}`],
            { [style.page__headerIconFinished]: finishedQuestionnaire });
        return (
            <section className={style.page} style={pageStyle}>
                <div className={style.page__wrapper}>
                    <div className={style.page__header}>
                        <div className={className(style.page__headerWrapper, { [style.disabled]: !isActive })}>
                            <span className={titleIconClassName}></span>
                            {title}
                        </div>
                    </div>
                    {this.props.children}
                    <SubmitButton {...props} disabled={!isActive} finished={finishedQuestionnaire} text={btnText} iconName={iconName}/>
                    <PageCover finished={finishedQuestionnaire} disabled={!isActive} id={pageIndex}/>
                </div>
            </section>
        );
    }
}


export class SubmitButton extends Component {
    constructor() {
        super();
        this._setActivePage = bindActionCreators(setActivePage);
        this.submitPage = this.submitPage.bind(this);
        this._setFieldValue = bindActionCreators(setFieldValue);
        this._completeQuestionnaire = bindActionCreators(completeQuestionnaire);
        this.keyDownHandler = this.keyDownHandler.bind(this);
    }
    submitPage() {
        const { nextPage, lastPageIndex, pageListSize, fieldValues }  = this.props;
        if ('function' === typeof this.props.transition && !this.props.transition(fieldValues)) {
            if ('object' === typeof this.props.actionObject) {
                dispatch(this.props.actionObject);
            }
            ReactDOM.findDOMNode(this).parentElement.querySelector('input').focus();
            return;
        }
        if (1 === pageListSize - nextPage) {
            this._completeQuestionnaire(nextPage);
            this._setActivePage(nextPage);
            animateScrollToPage(nextPage);
        } else if (nextPage < pageListSize && lastPageIndex <= pageListSize) {
            this._setActivePage(nextPage);
            this._setFieldValue('lastPageIndex', nextPage, 'pages');
            this._setFieldValue('currentPageIndex', nextPage, 'pages');
            animateScrollToPage(nextPage);
        }
    }
    keyDownHandler(event) {
        const disabled = this.props.disabled;
        const keyCode = event.keyCode;
        if (((ENTER === keyCode) || (SPACE === keyCode)) && !disabled) {
            this.submitPage();
            event.preventDefault();
        }
    }
    render() {
        const { iconName, text, finished, disabled } = this.props;
        const submitClassName = className(style.submitBtn, { [style.hidden]: finished && EMPTY_STRING !== iconName });
        const tabIndex = disabled ? -1 : 0;
        return (
            <div onClick={this.submitPage} className={submitClassName} tabIndex={tabIndex} onKeyDown={this.keyDownHandler}>
                <a className={style.submitBtn__btn}>
                    <span className={className(iconsStyle[`icon-${iconName}`], style.submitBtn__icon)}></span>
                    {text}
                </a>
            </div>
        );
    }
}

export class PageCover extends Component {
    constructor() {
        super();
        this.editPage = this.editPage.bind(this);
        this._setActivePage = bindActionCreators(setActivePage);
        this._setFieldValue = bindActionCreators(setFieldValue);
    }
    editPage() {
        if (this.props.finished) {
            return;
        }
        const pageId = this.props.id;
        this._setActivePage(pageId);
        this._setFieldValue('currentPageIndex', pageId, 'pages');
    }
    render() {
        const disabled = this.props.disabled;
        return disabled ? (
            <div className={style.coverWrapper} onClick={this.editPage}>
                <div className={style.coverWrapper__cover}></div>
                <div className={style.coverWrapper__text}>
                    <div className={style.coverWrapper__textWrapper}></div>
                </div>
            </div>
        ) : null;
    }
}

Page.ICONS = [
    { group: _('Welcome'),              icon: 'mail'        },
    { group: _('Personal Information'), icon: 'personal'    },
    { group: _('Health Information'),   icon: 'health'      },
    { group: _('Family Tree'),          icon: 'family'      },
    { group: _('Comments'),             icon: 'comments'    },
    { group: _('Final Step'),           icon: 'action-send' }
];
